module.exports = {
  "country": "MK",
  "artist": "Tamara Todevska",
  "song": "Proud",
  "year": "2019",
  "place": "7",
  "spotify": "4L2YQw0JBuYcS8M1uQKQjC"
};